import React from 'react';
import LocationTemplate from './LocationTemplate';

const WakeForestPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Wake Forest"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27587", "27588"]}
      latitude={35.9798}
      longitude={-78.5097}
      population={47601}
      historicalFact="Originally home to Wake Forest University before it relocated to Winston-Salem in 1956."
      nearbyTowns={[
        "Raleigh, NC",
        "Durham, NC",
        "Louisburg, NC",
        "Youngsville, NC",
        "Franklinton, NC",
        "Knightdale, NC",
        "Rolesville, NC",
        "Bunn, NC"
      ]}
    />
  );
};

export default WakeForestPage;